import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { TaskListModule } from 'src/app/shared/task-list/task-list.module';
import { DxTooltipModule, DxFormModule, DxToolbarModule, DxNumberBoxModule,DxAccordionModule,DxFileUploaderModule,DxDropDownButtonModule, DxButtonGroupModule, DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxContextMenuModule, DxDateBoxModule, DxDropDownBoxModule, DxGanttModule, DxPopupModule, DxRadioGroupModule, DxSchedulerModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTabPanelModule, DxTextBoxModule, DxTreeViewModule, DxDataGridComponent, DxDataGridModule, DxTagBoxModule, DxTextAreaModule, } from 'devextreme-angular';
import { ServiceListModule } from 'src/app/shared/service-list/service-list.module';

import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';
import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';

import { ReportViewerModule } from 'src/app/shared/report-viewer/report-viewer.module';

import { SignaturePadModule } from 'angular2-signaturepad';
import { ScheduleValuesModule } from 'src/app/shared/schedule-values/schedule-values.module';
import { DinamicModalComponent } from './dinamic-modal.component';
import { NewContactModule } from '../new-contact/new-contact.module';
import { NewCustomerModule } from 'src/app/pages/sales-management/employee-activities/forms/new-customer/new-customer.module';

@NgModule({
  declarations: [
    DinamicModalComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    TaskListModule,
    DxTreeViewModule,
    DxDropDownBoxModule,
    DxAccordionModule,
    DxTabPanelModule,
    DxButtonModule,
    DxContextMenuModule,
    DxSchedulerModule,
    DxDateBoxModule,
    DxGanttModule,
    DxTextBoxModule,
    DxRadioGroupModule,
    DxCheckBoxModule,
    DxPopupModule,
    DxScrollViewModule,
    DxAutocompleteModule,
    DxSelectBoxModule,
    DxSliderModule,
    ServiceListModule,
    DashboardModule,
    DxDataGridModule,
    DxTagBoxModule,
    DxButtonGroupModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    SharedDatagridModule,
    ReportViewerModule,
    SignaturePadModule,
    DxNumberBoxModule,
    DxToolbarModule,
    DxTextAreaModule,
    DxFormModule,
    ScheduleValuesModule,
    NewContactModule,
    NewCustomerModule,
    DxTooltipModule
  ],
  exports:[DinamicModalComponent]
})
export class DinamicModalModule { }
